export const ERROR = 'ERROR';
export const INVALIDATE = 'INVALIDATE';
export const INVALIDATE_PATH = 'INVALIDATE_PATH';
export const REQUEST = 'REQUEST';
export const RECEIVE = 'RECEIVE';
export const API_INVALIDATE = 'API_INVALIDATE';
export const API_INVALIDATE_PATH = 'API_INVALIDATE_PATH';
export const API_REQUEST = 'API_REQUEST';
